(function ($, document, window, undefined) {

    'use strict';
    

    var suites = {},
    shuffleInstance = null,
    lastFocus = null


    suites.bindEvents = function(){

        $('.modal-close').on('click', function(e){
            $('.modal').fadeOut('600')
            $('.modal').attr('aria-hidden', 'true')
            lastFocus.focus();
        })
    
        $('.floorplan-list a.floorplan').on('click', function (e) {
            e.preventDefault();
            var $parent = $(this).closest('a');
            suites.openModal($parent)
        })

        $('#floorplan-nav li').on('click keydown', function(e){

            
            if(e.type === 'click' || e.key === 'Enter' || e.keyCode === 13){
                e.preventDefault()
                $("#floorplan-nav li").removeClass('active')
                $(this).addClass('active')
        
                var $filter = $(this).attr('data-filter')
        
                suites.shuffler.filter($filter);
            }    

    
        })

        $('.suites.tabs .tab').on('click keydown', function(e){
            console.log(e)

            if(e.type === 'click' || e.key === 'Enter' || e.keyCode === 13){
                // Tab controls
                $('.suites.tabs .tab').removeClass('active')
                $(this).addClass('active')

                // Tabs
                var newtab = $(this).data('tab-control')
                newtab = '[data-tab="' + newtab + '"]'
                $("[data-tab]").removeClass('active')
                $(newtab).addClass('active')
                $("[data-tab]").attr('aria-hidden', 'true')
                $(newtab).attr('aria-hidden', 'false')
                //newtab.attr('aria-hidden', 'false')
                //$('.suites.tabs .tab').attr('aria-hidden', 'true')

            }            

        });

        $(document).ready(function(e) {

            var locationHash = window.location.hash;

            if(locationHash.length >= 1) {

                locationHash = locationHash.replace("#","");
                $("[data-tab-control="+locationHash+"]").trigger("click");
            }

        })

    } // END suites.bindEvents()

    suites.shuffler = function(){
        
        var init = function(){
            // Floorplan Sorting
            var Shuffle = window.Shuffle
            var element = document.querySelector('.floorplan-list')
            var sizer = element.querySelector('.floorplan')
    
            shuffleInstance = new Shuffle(element, {
                itemSelector: ".floorplan",
                sizer: sizer,
                gutterWidth: 32,
            })
    
            shuffleInstance.filter('', {
                by: function(element) {
                    return element.getAttribute('data-groups').toLowerCase()
                }
            })
            
        }

        var filter = function($filter) {
            if($filter == 'all'){
                shuffleInstance.filter('', {
                    by: function(element) {
                        return element.getAttribute('data-groups').toLowerCase()
                    }
                })
            } else {
                shuffleInstance.filter($filter, {
                    by: function(element) {
                        return element.getAttribute('data-name').toLowerCase()
                    }
                })
            }
        }

        return {
            init, filter
        }
    }();

    suites.trap_focus = function(element){
        var focusableEls = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), h1'),
            firstFocusableEl = focusableEls[0],
            lastFocusableEl = focusableEls[focusableEls.length - 1],
            KEYCODE_TAB = 9;

        if(firstFocusableEl && lastFocusableEl){
            element.addEventListener('keydown', function(e) {
                var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);
        
                if (!isTabPressed) { 
                    return; 
                }
        
                if ( e.shiftKey ) /* shift + tab */ {
                    if (document.activeElement === firstFocusableEl) {
                        lastFocusableEl.focus();
                        e.preventDefault();
                    }
                } else /* tab */ {
                    if (document.activeElement === lastFocusableEl) {
                        firstFocusableEl.focus();
                        e.preventDefault();
                    }
                }
        
            });
        }

    
    }    
    
    // Floorplan Popups
    suites.openModal = function($target) {

        var $pdf = $target.attr('href'),
            $thumb = $target.attr('data-thumbnail'),
            $id = $target.attr('id'),
            $title = $id.replace('floorplans_', ''),
            $title = 'floorplan-title-' + $title
            
            console.log($title)

        $('#floorplan-modal .floor-plan-img').attr('src', $thumb)
        $('#floorplan-modal .pdf-download-link').attr('href', $pdf)
        $('#floorplan-modal').fadeIn('600').css("display", "flex")

        $('#floorplan-modal .modal-inner').attr('aria-labelledby', $title)
        $('#floorplan-modal').attr('aria-hidden', 'false')

        lastFocus = document.activeElement;
        console.log(lastFocus)
        $('.modal .modal-close').focus()

        let modal = document.querySelector('.modal-floorplans')

        suites.trap_focus(modal)



    }

    suites.mobileDropdown = function() {
        var $ = jQuery;

        // Create the dropdown base
        $("<label for='floorplan-select' class='visuallyhidden'>Select number of bedrooms</label>").insertAfter("#floorplan-nav");        
        $("<select id='floorplan-select' />").insertAfter("#floorplan-nav");

        // Populate dropdown with menu items
        $("#floorplan-nav li").each(function() {
        var el = $(this);
            
        $("<option />", {
            "value"   : el.attr("data-filter"),
            "text"    : el.text()
        }).appendTo("#floorplan-select");
        });

        $('#floorplan-select').on('change', function(e){
            suites.shuffler.filter($(this).val());
        })
        
        /*
        $("#floorplan-select").selectric({
            disableOnMobile: false,
            nativeOnMobile: false
        });
        */
    }

    suites.accordion = function(){
        //$('.feature:not(.active) .collapsable-content').hide()
        $('.feature .collapsable-content').hide()

        $('.feature .feature-title').on('click', function(e) {

            function expand(feature){
                //console.log(feature)
                feature.classList.add('active')
                feature.querySelector('.feature-title').setAttribute('aria-expanded', 'true');
                $(feature).find('.collapsable-content').slideDown()
            }
            function collapse(feature){
                //console.log(feature)
                feature.classList.remove('active')
                feature.querySelector('.feature-title').setAttribute('aria-expanded', 'false');
                $(feature).find('.collapsable-content').slideUp()
            }

            if(e.type === 'click'){
                var feature = this.parentNode
                if (feature.classList.contains('active')){
                    collapse(feature)
                } else {
                    expand(feature)
                }
            }

        })


    }

    suites.init = function(){
        suites.bindEvents()
        suites.shuffler.init()
        suites.accordion()
        suites.mobileDropdown()
    }

    if (!window.Frontier) window.Frontier = {};
        window.Frontier.Suites = suites;



}(jQuery, document, window));